import { useLazyQuery, useQuery } from "@apollo/client";
import { useEffect } from "react";

import Account from "@components/account/Account";
import HandleQuery from "@components/HandleQuery";
import ExpertJourneyPage from "@components/pageTypes/ExpertJourneyPage";
import {
  GetClientWithAccountDocument,
  GetClientWithAccountQuery,
  GetClientWithAccountQueryVariables,
  GetJourneyWithOwnerClientDocument,
  GetJourneyWithOwnerClientQuery,
  GetJourneyWithOwnerClientQueryVariables
} from "@typing/Generated";

type Props = {
  journeyId: string;
};

const ExpertJourneyClientAccountPage = ({ journeyId }: Props) => {
  const journeyQuery = useQuery<GetJourneyWithOwnerClientQuery, GetJourneyWithOwnerClientQueryVariables>(
    GetJourneyWithOwnerClientDocument,
    {
      variables: {
        id: journeyId
      }
    }
  );

  const [getClient, getClientWithAccountQuery] = useLazyQuery<
    GetClientWithAccountQuery,
    GetClientWithAccountQueryVariables
  >(GetClientWithAccountDocument);

  useEffect(() => {
    if (journeyQuery.data?.journey.owner.id) getClient({ variables: { id: journeyQuery.data.journey.owner.id } });
  }, [getClient, journeyQuery.data?.journey.id, journeyQuery.data?.journey.owner.id]);

  return (
    <ExpertJourneyPage helmetKey="pageTitles.client.carePlan.show" journeyId={journeyId} mobileFullscreen>
      <HandleQuery hideLoader query={getClientWithAccountQuery}>
        {data => <Account client={data.client} journeyId={journeyId} />}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyClientAccountPage;
